/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".centered[_ngcontent-%COMP%]{position:absolute;width:600px;height:300px;left:30%;top:30%}label[_ngcontent-%COMP%]{width:-webkit-fill-available}.message[_ngcontent-%COMP%]{color:#6286f3;font-size:30px;font-weight:700;text-align:center}.buttons[_ngcontent-%COMP%]{text-align:-webkit-center;margin-top:20px}"];
export { styles as styles };
